import Navbar from './../Navbar';
import React from 'react';

function Gallery() {
  return (
    <div className="background-home">
      <div className="overlay">
        <Navbar />
        <div className="content">
        </div>
      </div>
    </div>
  );
}

export default Gallery;